import { useQuery } from '@tanstack/react-query';

export function useOrganizationOnboardingStatusQuery(org_id) {
  const fetchOnboardingStatus = async () => {
    const response = await fetch(`/api/organization_dashboard_status?organization_id=${org_id}`);
    if (!response.ok) {
      throw new Error('Failed to fetch onboarding status');
    }
    return response.json();
  };

  return useQuery(['organizationOnboardingStatus', org_id], fetchOnboardingStatus);
}
